import Vue from 'vue';
import VueI18n from 'vue-i18n'

Vue.use( VueI18n )

const messages = {
    'de-DE': {
        message: {
            searchInput: 'Suchfeld'
        }
    },
    'fr-FR': {
        message: {
            searchInput: 'Champ de recherche'
        }
    },
    'nl': {
        message: {
            searchInput: 'Zoekveld'
        }
    },
    'nl-NL': {
        message: {
            searchInput: 'Zoekveld'
        }
    },
    'en': {
        message: {
            searchInput: 'Searchinput'
        }
    },
}

const i18n = new VueI18n( {
    locale: document.documentElement.lang,
    fallbackLocale: 'en',
    messages
} );

export default i18n;
